import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { z } from 'zod';

export const pharmacyInitiateClaimRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/claims/initiate',
  validateSearch: z.object({
    documentId: z.coerce.string().optional(),
    documentDownloadUrl: z.string().optional(),
    documentOrigin: z.enum(['digipharmacie', 'real_invoice']).optional(),
  }),
}).lazy(() =>
  import('pages/pharmacy/Cases/Claims/InitiatePharmacyClaimPage/InitiatePharmacyClaimPage').then(
    (d) => d.Route
  )
);
